import React from "react";
// import CommonBanner
import CommonBanner from "../component/Common/CommonBanner";
// import ErrorArea
import ErrorArea from "../component/Error";
import Seo from "component/Common/seo";

const Error = () => {
    return (
        <>
            <Seo
                title="Page introuvable | Je Voyage Ici"
                description="La page demandée est introuvable."
                canonical="/404"
            />
            <CommonBanner heading="Error" pagination="Error" />
            <ErrorArea />
        </>
    );
};

export default Error;
